/* ebb+sol app landing page behaviour: waitlist signup, film, gallery and scroll reveals. */
(function () {
  document.documentElement.classList.add('es-js');

  var config = window.EBBSOL || {};
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Waitlist forms post to Klaviyo's public client API. A form can name its own list (data-list-id); otherwise it joins the App Waitlist.
  function subscribe(email, source, listId, customSource) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(config.klaviyoCompanyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2025-01-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource || 'App landing page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { signup_source: source },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId || config.waitlistListId } } }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Signup failed with status ' + response.status);
    });
  }

  function setStatus(form, message, state) {
    var status = form.querySelector('.es-form__status');
    status.textContent = message;
    status.dataset.state = state || '';
  }

  document.querySelectorAll('[data-es-waitlist]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var consent = form.querySelector('input[name="consent"]');
      var button = form.querySelector('button[type="submit"]');
      var email = input.value.trim();

      input.removeAttribute('aria-invalid');
      if (!EMAIL_PATTERN.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        setStatus(form, 'Please enter a valid email address.', 'error');
        input.focus();
        return;
      }
      if (!consent.checked) {
        setStatus(form, 'Please tick the box so we can send you launch updates.', 'error');
        consent.focus();
        return;
      }

      button.disabled = true;
      setStatus(form, 'Adding you to the list…', '');

      subscribe(email, form.dataset.source || 'app-landing-page', form.dataset.listId, form.dataset.customSource)
        .then(function () {
          var success = document.createElement('p');
          success.className = 'es-form-success';
          success.setAttribute('role', 'status');
          success.setAttribute('tabindex', '-1');
          success.textContent = form.dataset.success;
          form.replaceWith(success);
          success.focus();
          if (typeof window.gtag === 'function') window.gtag('event', 'sign_up', { method: 'app_waitlist', source: form.dataset.source });
        })
        .catch(function () {
          button.disabled = false;
          setStatus(form, 'Something went wrong and you are not on the list yet. Please try again.', 'error');
        });
    });
  });

  // Film: user-initiated, starts muted, native controls take over after the first play.
  document.querySelectorAll('[data-es-film]').forEach(function (frame) {
    var video = frame.querySelector('video');
    var play = frame.querySelector('.es-film__play');
    if (!video || !play) return;
    play.addEventListener('click', function () {
      frame.classList.add('is-playing');
      video.setAttribute('controls', '');
      video.play().catch(function () {});
      video.focus();
    });
  });

  // Gallery arrows, shown only when the screens overflow.
  document.querySelectorAll('[data-es-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.es-track');
    var controls = gallery.querySelector('.es-gallery__controls');
    var prev = gallery.querySelector('[data-es-prev]');
    var next = gallery.querySelector('[data-es-next]');
    if (!track || !controls) return;

    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      controls.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    function step(direction) {
      var slide = track.querySelector('.es-slide');
      var amount = slide ? slide.getBoundingClientRect().width + 40 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Product gallery: thumbnails scroll the main viewer, and the current thumbnail follows swipes.
  document.querySelectorAll('[data-es-product-gallery]').forEach(function (gallery) {
    var viewer = gallery.querySelector('.es-product__viewer');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.es-product__thumb'));
    if (!viewer || !thumbs.length) return;
    function mark(index) {
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = document.getElementById(thumb.dataset.esTarget);
        if (slide) viewer.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        mark(i);
      });
    });
    viewer.addEventListener('scroll', function () {
      mark(Math.round(viewer.scrollLeft / viewer.clientWidth));
    }, { passive: true });
    mark(0);
  });

  // Reveal on scroll.
  var reveals = document.querySelectorAll('.es-reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
